import React from 'react';
import './preloader.css'; // We'll define the CSS here

const Preloader = () => {
  return (
    <div className="preloader-container">
      <img src="assets/images/logo.png" alt="Logo" className="preloader-logo" />
    </div>
  );
};

export default Preloader;
